module.exports = __webpack_public_path__ + "img/set-item6.6fef4892.png";